export enum RouteType {
  // home
  Home = '/',

  // workflow
  Services = '/services',
  Employees = '/employees',
  AvailableTimes = '/available-times',
  BookingConfirmation = '/booking-confirmation',

  // appointment
  CancelAppointment = '/cancel-appointment',
  RescheduleAppointment = '/reschedule-appointment',

  // auth
  Login = '/login',
  ResetPassword = '/passwort-zuruecksetzen',
  ConfirmEmail = '/benutzer-aktivieren',

  // user
  Profile = '/profile',
  UserBookings = '/user-bookings'
}
